export default require('./InputCheckbox').default
